import { createAsyncThunk } from '@reduxjs/toolkit';

import { ICultureDTO, LocalizationsDTO } from 'src/api/dtos';
import LocalizationRepository from 'src/api/repositories/common/v1/localization.repository';

export const fetchLocalizations = createAsyncThunk<LocalizationsDTO, void>(
  'localizations/languages',
  async (_, { rejectWithValue }) => {
    try {
      const repository = new LocalizationRepository();
      return await repository.get();
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const fetchCultures = createAsyncThunk<ICultureDTO[], void>(
  'localizations/cultures',
  async (_, { rejectWithValue }) => {
    try {
      const repository = new LocalizationRepository();
      return await repository.getCultures();
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
